import {
  FETCHING_CLUSTERS,
  FETCHING_CLUSTERS_SUCCEEDED,
  FETCHING_CLUSTERS_FAILED,
  FETCHING_CLUSTER,
  FETCHING_CLUSTER_SUCCEEDED,
  FETCHING_CLUSTER_FAILED,
  FETCHING_ASSETS_CONTENT_MAP,
  FETCHING_ASSETS_CONTENT_MAP_SUCCEEDED,
  FETCHING_ASSETS_CONTENT_MAP_FAILED,
  CREATING_CLUSTER,
  CREATING_CLUSTER_SUCCEEDED,
  CREATING_CLUSTER_FAILED,
  DELETING_CLUSTER,
  DELETING_CLUSTER_SUCCEEDED,
  DELETING_CLUSTER_FAILED,
  UPDATING_CLUSTER,
  UPDATING_CLUSTER_SUCCEEDED,
  UPDATING_CLUSTER_FAILED,
  INVALIDATE_CONTENT_MAP_ASSETS,
  DELETE_ASSETS_CONTENT_MAP,
  DELETE_ASSETS_CONTENT_MAP_FAILED,
  DELETE_ASSETS_CONTENT_MAP_SUCCEEDED,
  UPDATE_ASSETS_CONTENT_MAP,
  UPDATE_ASSETS_CONTENT_MAP_FAILED,
  UPDATE_ASSETS_CONTENT_MAP_SUCCEEDED,
  FETCH_ASSETS_FOR_DOWNLOAD,
  FETCHING_ASSETS_FOR_DOWNLOAD_FAILED,
  FETCHING_ASSETS_FOR_DOWNLOAD_SUCCEEDED,
  INVALIDATE_ASSETS_FOR_DOWNLOAD,
  INVALIDATE_CONTENT_DATA,
  FETCHING_ASSETS_FOR_CONTENT_SCORE_CARD,
  FETCHING_ASSETS_FOR_CONTENT_SCORE_CARD_SUCCEEDED,
  FETCHING_ASSETS_FOR_CONTENT_SCORE_CARD_FAILED,
  FETCHING_CONTENT_GRAPH_VALUES,
  FETCHING_CONTENT_GRAPH_VALUES_SUCCEEDED,
  FETCHING_CONTENT_GRAPH_VALUES_FAILED,
  FETCHING_CONTENT_SCORE,
  FETCHING_CONTENT_SCORE_SUCCEEDED,
  FETCHING_CONTENT_SCORE_FAILED
} from './actionTypes';

import {
  ErrorResponse,
  FetchClusterRequest,
  FetchClusterErrorResponse,
  FetchAssetsRequest,
  FetchAssetsResponse,
  CreateClusterRequest,
  UpdateClusterRequest,
  DeleteAssetsRequest,
  UpdateAssetsRequest,
  FetchAssetsForContentScoreRequest,
  FetchAssetsForContentScoreResponse,
  FetchAssetsForContentScoreErrorResponse,
  FetchContentGraphValuesRequest,
  FetchContentGraphValuesResponse,
  FetchContentGraphValuesErrorResponse,
  FetchingContentScoreResponse,
  FetchingContentScoreErrorResponse
} from "../../types/contentMap";

import { Cluster } from 'src/types/clusterFilters';

import axios from "axios";
import { createAction } from "@reduxjs/toolkit";
import { takeEvery, call, put } from "redux-saga/effects";

const apiUrl = `${process.env.REACT_APP_API_URL}`;
const FILTERS_BASE_URL = `${apiUrl}/api/2.0/filter_command`;
const ASSETS_BASE_URL = `${apiUrl}/api/2.0/assets`;
const CONTENT_BASE_URL = `${apiUrl}/api/2.0`;

export const fetchClusters = createAction<void>(FETCHING_CLUSTERS);
const fetchingClustersSucceeded = createAction<Cluster[]>(FETCHING_CLUSTERS_SUCCEEDED);
const fetchingClustersFailed = createAction<ErrorResponse>(FETCHING_CLUSTERS_FAILED);

const fetchingClustersSaga = function* (): any {

  const fetchClustersApi = () => {
    return axios({
      method: 'GET',
      url: FILTERS_BASE_URL
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchClustersApi);
    yield put(fetchingClustersSucceeded(response));
  } catch (error) {
    yield put(fetchingClustersFailed({ error: error }));
  }

}


export const fetchCluster = createAction<FetchClusterRequest>(FETCHING_CLUSTER);
const fetchingClusterSucceeded = createAction<Cluster>(FETCHING_CLUSTER_SUCCEEDED);
const fetchingClusterFailed = createAction<FetchClusterErrorResponse>(FETCHING_CLUSTER_FAILED);

const fetchingClusterSaga = function* (action: ReturnType<typeof fetchCluster>): any {
  const clusterId = action.payload.id;

  const fetchClustersApi = () => {
    return axios({
      method: 'GET',
      url: `${FILTERS_BASE_URL}/${clusterId}`
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchClustersApi);
    yield put(fetchingClusterSucceeded(response));
  } catch (error) {
    yield put(fetchingClusterFailed({ id: clusterId, error: error }));
  }

}

export const fetchAssets = createAction<FetchAssetsRequest>(FETCHING_ASSETS_CONTENT_MAP);
const fetchingAssetsSucceeded = createAction<FetchAssetsResponse>(FETCHING_ASSETS_CONTENT_MAP_SUCCEEDED);
const fetchingAssetsFailed = createAction<ErrorResponse>(FETCHING_ASSETS_CONTENT_MAP_FAILED);
export const invalidateContentMapAssets = createAction<void>(INVALIDATE_CONTENT_MAP_ASSETS);

export const fetchAssetsForDownload = createAction<FetchAssetsRequest>(FETCH_ASSETS_FOR_DOWNLOAD);
const fetchingAssetsForDownloadSucceeded = createAction<FetchAssetsResponse>(FETCHING_ASSETS_FOR_DOWNLOAD_SUCCEEDED);
const fetchingAssetsForDownloadFailed = createAction<ErrorResponse>(FETCHING_ASSETS_FOR_DOWNLOAD_FAILED);
export const invalidateDownloadAssets = createAction<void>(INVALIDATE_ASSETS_FOR_DOWNLOAD);
export const invalidateContentData = createAction<void>(INVALIDATE_CONTENT_DATA);

const fetchingAssetsSaga = function* (action: ReturnType<typeof fetchAssets>): any {
  const { requestBody, page, isForDownload } = action.payload;

  const fetchAssetsApi = () => {
    return axios({
      method: 'POST',
      url: `${CONTENT_BASE_URL}/content_map`,
      data: requestBody,
      params: {
        page: page,
        limit: 20
      }
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchAssetsApi);
    const actionType = isForDownload ? fetchingAssetsForDownloadSucceeded : fetchingAssetsSucceeded;
    yield put(actionType({ response }));
  } catch (error) {
    const actionType = isForDownload ? fetchingAssetsForDownloadFailed : fetchingAssetsFailed ;
    yield put(actionType({ error }));
  }

}

export const createCluster = createAction<CreateClusterRequest>(CREATING_CLUSTER);
const creatingClusterSucceeded = createAction<Cluster>(CREATING_CLUSTER_SUCCEEDED);
const creatingClusterFailed = createAction<ErrorResponse>(CREATING_CLUSTER_FAILED);

const creatingClusterSaga = function* (action: ReturnType<typeof createCluster>): any {
  const { requestBody } = action.payload;

  const createClusterApi = () => {
    return axios({
      method: 'POST',
      url: FILTERS_BASE_URL,
      data: requestBody,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(createClusterApi);
    yield put(creatingClusterSucceeded(response));
  } catch (error) {
    yield put(creatingClusterFailed({ error: error }));
  }

}

export const deleteCluster = createAction<{ id: string }>(DELETING_CLUSTER);
const deletingClusterSucceeded = createAction<any>(DELETING_CLUSTER_SUCCEEDED);
const deletingClusterFailed = createAction<ErrorResponse>(DELETING_CLUSTER_FAILED);

const deletingClusterSaga = function* (action: ReturnType<typeof deleteCluster>): any {
  const { id } = action.payload;

  const deleteClusterApi = () => {
    return axios({
      method: 'DELETE',
      url: `${FILTERS_BASE_URL}/${id}`
    }).then((response) => response.data);
  };

  try {
    const response = yield call(deleteClusterApi);
    yield put(deletingClusterSucceeded(response));
  } catch (error) {
    yield put(deletingClusterFailed({ error: error }));
  }

}

export const updateCluster = createAction<UpdateClusterRequest>(UPDATING_CLUSTER);
const updatingClusterSucceeded = createAction<Cluster>(UPDATING_CLUSTER_SUCCEEDED);
const updatingClusterFailed = createAction<ErrorResponse>(UPDATING_CLUSTER_FAILED);

const updatingClusterSaga = function* (action: ReturnType<typeof updateCluster>): any {
  const { id, requestBody } = action.payload;

  const updateClusterApi = () => {
    return axios({
      method: 'PUT',
      url: `${FILTERS_BASE_URL}/${id}`,
      data: requestBody,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(updateClusterApi);
    yield put(updatingClusterSucceeded(response));
  } catch (error) {
    yield put(updatingClusterFailed({ error: error }));
  }

}

export const deleteAssets = createAction<DeleteAssetsRequest>(DELETE_ASSETS_CONTENT_MAP);
const deletingAssetsSucceeded = createAction<any>(DELETE_ASSETS_CONTENT_MAP_SUCCEEDED);
const deletingAssetsFailed = createAction<ErrorResponse>(DELETE_ASSETS_CONTENT_MAP_FAILED);

const deletingAssetsSaga = function* (action: ReturnType<typeof updateCluster>): any {
  const requestBody = action.payload;

  const updateClusterApi = () => {
    return axios({
      method: 'DELETE',
      url: `${ASSETS_BASE_URL}/bulk_delete`,
      data: requestBody,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(updateClusterApi);
    yield put(deletingAssetsSucceeded(response));
  } catch (error) {
    yield put(deletingAssetsFailed({ error: error }));
  }
}


export const updateAssets = createAction<UpdateAssetsRequest>(UPDATE_ASSETS_CONTENT_MAP);
const updatingAssetsSucceeded = createAction<any>(UPDATE_ASSETS_CONTENT_MAP_SUCCEEDED);
const updatingAssetsFailed = createAction<ErrorResponse>(UPDATE_ASSETS_CONTENT_MAP_FAILED);

const updatingAssetsSaga = function* (action: ReturnType<typeof updateCluster>): any {
  
  const requestBody = action.payload;

  const updateClusterApi = () => {
    return axios({
      method: 'PUT',
      url: `${ASSETS_BASE_URL}/bulk_update`,
      data: requestBody,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(updateClusterApi);
    yield put(updatingAssetsSucceeded(response));
  } catch (error) {
    yield put(updatingAssetsFailed({ error: error }));
  }
}

// fetch assets for content score card
export const fetchAssetsForContentScoreCard = createAction<FetchAssetsForContentScoreRequest>(FETCHING_ASSETS_FOR_CONTENT_SCORE_CARD);
const fetchAssetsForContentScoreCardSucceeded = createAction<FetchAssetsForContentScoreResponse>(FETCHING_ASSETS_FOR_CONTENT_SCORE_CARD_SUCCEEDED);
const fetchAssetsForContentScoreCardFailed = createAction<FetchAssetsForContentScoreErrorResponse>(FETCHING_ASSETS_FOR_CONTENT_SCORE_CARD_FAILED);
const fetchingAssetsForContentScoreCardSaga = function* (action: ReturnType<typeof fetchAssetsForContentScoreCard>): any {

  const { category, value, page } = action.payload;

  const request = {
    category: category,
    value: value
  }

  const fetchingAssetsForContentScoreCardApi = () => {
    return axios({
      method: 'POST',
      url: `${CONTENT_BASE_URL}/content_map/filters`,
      data: request,
      params: {
        page: page,
        limit: 20
      }
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchingAssetsForContentScoreCardApi);
    yield put(fetchAssetsForContentScoreCardSucceeded({ response }));
  } catch (error) {
    yield put(fetchAssetsForContentScoreCardFailed({ error }));
  }
}

//fetch content graph values
export const fetchContentGraphValues = createAction<FetchContentGraphValuesRequest>(FETCHING_CONTENT_GRAPH_VALUES);
const fetchContentGraphValuesSucceeded = createAction<FetchContentGraphValuesResponse>(FETCHING_CONTENT_GRAPH_VALUES_SUCCEEDED);
const fetchContentGraphValuesFailed = createAction<FetchContentGraphValuesErrorResponse>(FETCHING_CONTENT_GRAPH_VALUES_FAILED);
const fetchingContentGraphValuesSaga = function* (action: ReturnType<typeof fetchContentGraphValues>): any {

  const { category, value } = action.payload;

  const request = {
    category: category,
    value: value
  }

  const fetchingContentGraphValuesApi = () => {
    return axios({
      method: 'POST',
      url: `${CONTENT_BASE_URL}/content_map/graph`,
      data: request,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchingContentGraphValuesApi);
    yield put(fetchContentGraphValuesSucceeded({ response }));
  } catch (error) {
    yield put(fetchContentGraphValuesFailed({ error }));
  }
}

// fetch score for content
export const fetchContentScore = createAction(FETCHING_CONTENT_SCORE);
export const fetchingContentScoreSucceeded = createAction<FetchingContentScoreResponse>(FETCHING_CONTENT_SCORE_SUCCEEDED);
export const fetchingContentScoreFailed = createAction<FetchingContentScoreErrorResponse>(FETCHING_CONTENT_SCORE_FAILED);
const fetchingContentScoreSaga = function* (): any {

  const fetchingContentScoreApi = () => {
    return axios({
      method: 'GET',
      url: `${CONTENT_BASE_URL}/content_map/score`,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchingContentScoreApi);
    yield put(fetchingContentScoreSucceeded({ response }));
  } catch (error) {
    yield put(fetchingContentScoreFailed({ error }));
  }
}

export default function* contentMapSaga() {
  yield takeEvery(FETCHING_CLUSTERS, fetchingClustersSaga);
  yield takeEvery(FETCHING_CLUSTER, fetchingClusterSaga);
  yield takeEvery(FETCHING_ASSETS_CONTENT_MAP, fetchingAssetsSaga);
  yield takeEvery(FETCH_ASSETS_FOR_DOWNLOAD, fetchingAssetsSaga);
  yield takeEvery(CREATING_CLUSTER, creatingClusterSaga);
  yield takeEvery(DELETING_CLUSTER, deletingClusterSaga);
  yield takeEvery(UPDATING_CLUSTER, updatingClusterSaga);
  yield takeEvery(DELETE_ASSETS_CONTENT_MAP, deletingAssetsSaga);
  yield takeEvery(UPDATE_ASSETS_CONTENT_MAP, updatingAssetsSaga);
  yield takeEvery(FETCHING_ASSETS_FOR_CONTENT_SCORE_CARD, fetchingAssetsForContentScoreCardSaga)
  yield takeEvery(FETCHING_CONTENT_GRAPH_VALUES, fetchingContentGraphValuesSaga);
  yield takeEvery(FETCHING_CONTENT_SCORE, fetchingContentScoreSaga);
}